import { truncateText } from "../../../../src/_helpers/_utilities";
import { useMemo } from "react";

export default function Article({ article }) {
	const categoryUrl = useMemo(() => {
		return article.category.toLowerCase().replaceAll(" ", "-");
	}, [article.category]);

	return (
		<div className="col-sm-6 col-md-4 mb-4 mb-md-15" key={article.slug}>
			<div className="overflow-hidden">
				<div
					style={{
						width: "100%",
						height: 250,
						backgroundImage: `url(${article.feature_image.url.replaceAll("(", "%28").replaceAll(")", "%29")})`,
						backgroundColor: "#eee",
						backgroundSize: "cover",
						backgroundPosition: "center",
					}}
				/>
				<div className="">
					<a href={`/blog/${categoryUrl}`} className="d-block text-gray-black font-size-lg text-underline mt-5 mb-4">
						{article.category}
					</a>
					<a className="h3 text-no-underline text-gray-black" href={`/blog/${article.slug}/`}>
						{article.title}
					</a>
					<div className="mt-3 font-size-lg">{truncateText(article.content.text, 200)}</div>
					<div className="pt-2_5">
						<span className="font-size-xs text-light-gray ">{article.time_to_read} minutes read</span>
					</div>
				</div>
			</div>
		</div>
	);
}
